import Tracker from './Tracker'

const checkMethod = () => typeof window.mm_send === 'function'

class MaxyMiser extends Tracker {
  async init() {
    const env = this.props.env
    const url = this.props.url?.[env]

    /* istanbul ignore next */
    url &&
      !(function (i, s, o, g, r, a, m) {
        if (i[r]) return
        a = s.createElement(o)
        m = s.getElementsByTagName(o)[0]
        a.src = g
        m.parentNode.insertBefore(a, m)
      })(window, document, 'script', url, 'mm_send')
    /* eslint-enable no-unused-expressions */
  }

  event(event, firstLoad, ...args) {
    let checker,
      count = 0
    const fireEvent = () => {
      count++
      if (checkMethod()) {
        window.mm_send(...args)
        clearInterval(checker)
      } else if (count >= 10) {
        clearInterval(checker)
      }
    }

    if (checkMethod()) {
      fireEvent()
    } else {
      checker = setInterval(fireEvent, 1000)
    }
  }
}

export default MaxyMiser
